<template>
  <button class="aeb-base-button" :class="variant" :disabled="disabled">
    <div v-if="hasIcon" class="icon">
      <slot name="icon" />
    </div>
    <span>
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: Boolean,
    required: false,
    default: false,
  },
  variant: {
    type: String,
    required: false,
    default: 'blue',
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const hasIcon = computed(() => props.icon);
const variant = computed((): string => {
  switch (props.variant) {
    case 'light':
      return 'aeb-light-button';
      break;
    case 'white':
      return 'aeb-white-button';
      break;
    case 'link':
      return 'aeb-link-button';
      break;
    case 'red':
      return 'aeb-red-button';
      break;
    default:
      return 'aeb-default-button';
      break;
  }
});
</script>

<style lang="scss" scoped>
.aeb-base-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  line-height: 21px;
  padding: 0 26px;
  box-sizing: border-box;
  border-radius: $border-radius-size;
  font-size: 18px;
  user-select: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: normal;
  width: 100%;

  &.aeb-default-button {
    background-color: $blue;
    color: $white;
    border: none;

    &:hover {
      background-color: $blue-hover;
    }

    &:active {
      background-color: $blue-active;
    }
  }

  &.aeb-white-button {
    background-color: $white;
    color: $blue;
    border: none;

    &:hover {
      background-color: $white-hover;
    }

    &:active {
      background-color: $white-active;
    }
  }

  &.aeb-light-button {
    background-color: $lightblue;
    color: $blue;
    border: none;

    &:hover {
      background-color: $lightblue-hover;
    }

    &:active {
      background-color: $lightblue-active;
    }
  }

  &.aeb-red-button {
    background-color: $lightred;
    color: $red;
    border: none;

    &:hover {
      background-color: $lightred-hover;
    }

    &:active {
      background-color: $lightred-active;
    }
  }

  &.aeb-link-button {
    background-color: transparent;
    color: $blue;
    border: none;
    padding: 0;
    height: auto;
    line-height: normal;
    border-radius: 2px;

    &:hover {
      background-color: transparent;
      text-decoration: underline;
    }

    &:active {
      background-color: transparent;
      text-decoration: none;
    }
  }

  &.aeb-stroke-button {
    background-color: transparent;
    color: $blue;
    border: 2px solid $blue;

    &:hover {
      border: 2px solid $others-turquoise;
    }

    &:active {
      border: 2px solid $others-turquoise-active;
    }
  }

  .icon {
    display: flex;
    width: 18px;
    height: 18px;
    margin-right: 14px;
    align-items: center;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}
</style>
